var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "limited-time-offer-editor" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "description",
          staticStyle: { "margin-bottom": "12px" },
        },
        [
          _vm._v(
            "\n        Add text to create urgency for your offer. The expiration time will be set when you send the message.\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c("a-input", {
        staticStyle: { "margin-bottom": "12px" },
        attrs: {
          value: _vm.data.text,
          placeholder: "e.g., Expiring offer!, Flash sale!",
          maxLength: 60,
        },
        on: { input: _vm.updateText },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "char-count" }, [
        _vm._v(_vm._s((_vm.data.text || "").length) + "/60"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "lto-expiration-toggle" },
        [
          _c(
            "a-checkbox",
            {
              attrs: { checked: _vm.data.hasExpiration },
              on: { change: _vm.updateHasExpiration },
            },
            [_vm._v("\n            Show expiration timer\n        ")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "hint-text" }, [
            _vm._v(
              "\n            When enabled, WhatsApp will display a countdown timer based on when the message is sent.\n        "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Limited Time Offer "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }